/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ares_Legal_Form_141Inputs */

const cs_ares_legal_form_141 = /** @type {(inputs: Ares_Legal_Form_141Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obecně prospěšná společnost`)
};

const en_ares_legal_form_141 = /** @type {(inputs: Ares_Legal_Form_141Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public-benefit company`)
};

/**
* | output |
* | --- |
* | "Public-benefit company" |
*
* @param {Ares_Legal_Form_141Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ares_legal_form_141 = /** @type {((inputs?: Ares_Legal_Form_141Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ares_Legal_Form_141Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ares_legal_form_141(inputs)
	return cs_ares_legal_form_141(inputs)
});